var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgPuzzlePieceFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 5A.75.75 0 0 1 4 4.25h4a.75.75 0 0 1 .75.75v.992a1.24 1.24 0 0 0 .023.167c.026.126.078.287.175.444.166.265.542.647 1.552.647s1.386-.382 1.552-.647a1.371 1.371 0 0 0 .198-.61V5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v3.547c.346-.15.788-.297 1.25-.297 1.518 0 2.75 1.448 2.75 3.25s-1.232 3.25-2.75 3.25c-.462 0-.904-.147-1.25-.297V17a.75.75 0 0 1-.75.75h-3.547c.15.346.297.788.297 1.25 0 .718-.342 1.512-.873 2.119-.544.621-1.361 1.131-2.377 1.131-1.016 0-1.833-.51-2.377-1.131-.531-.607-.873-1.401-.873-2.119 0-.462.147-.904.297-1.25H4a.75.75 0 0 1-.75-.75V5Z", fill: "currentColor" })));
});
export default SvgPuzzlePieceFill;
